var _filter, _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgS1A4Ele(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 842,
    viewBox: "0 0 595 842",
    width: 595,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 205.545,
    width: 649.091,
    x: -27.0455,
    y: 654.5
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.49091
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.494118 0 0 0 0 0.694118 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_2744_158498"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2744_158498",
    mode: "normal",
    result: "shape"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h595v842h-595z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fae9f2",
    height: 110.345,
    rx: 44.3545,
    width: 553.891,
    x: 20.5544,
    y: 695.609
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ea0d8b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32.9124 721.208c-4.3775.085-7.5174-2.734-7.601-7.053-.0577-2.981.8715-6.394 3.7309-12.929l3.6194-8.401c.2865-.623.8755-1.046 1.5719-1.059l4.8751-.095c.8954-.017 1.4047.59 1.1242 1.522l-4.3079 13.968c2.6086 1.081 4.3477 3.516 4.4074 6.601.0816 4.215-2.9429 7.359-7.42 7.446zm19.0026-.368c-4.3775.085-7.5175-2.734-7.601-7.053-.0577-2.981.8715-6.393 3.7308-12.929l3.6195-8.401c.2865-.623.8755-1.045 1.5719-1.059l4.875-.094c.8954-.018 1.4048.59 1.1243 1.521l-4.3079 13.969c2.6086 1.081 4.3477 3.515 4.4074 6.6.0815 4.215-2.9429 7.36-7.42 7.446z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m561.367 788.79c4.378-.085 7.518 2.734 7.601 7.053.058 2.981-.871 6.393-3.731 12.929l-3.619 8.401c-.287.623-.876 1.046-1.572 1.059l-4.875.094c-.896.018-1.405-.59-1.124-1.521l4.308-13.969c-2.609-1.08-4.348-3.515-4.408-6.6-.081-4.215 2.943-7.36 7.42-7.446zm-19.002.368c4.377-.085 7.517 2.734 7.601 7.052.057 2.982-.872 6.394-3.731 12.929l-3.62 8.402c-.286.622-.875 1.045-1.572 1.059l-4.875.094c-.895.017-1.404-.59-1.124-1.521l4.308-13.969c-2.609-1.081-4.348-3.516-4.407-6.6-.082-4.216 2.942-7.36 7.42-7.446z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1A4Ele);
export default __webpack_public_path__ + "static/media/S1_A4_ELE.0ea903bd6c7b58f252b761b505fc5d2c.svg";
export { ForwardRef as ReactComponent };